module.exports = __webpack_public_path__ + "img/footer-circle-right.837ca57.svg";